<template>
    <div id="app">
        <cache-reset v-if="tool === 'reset'" />

        <image-builder v-if="tool === 'builder'" />

        <url-tweaker v-if="tool === 'url'" />

        <color-conversion v-if="tool === 'color'" />

        <div class="tools">
            <p>
                <button
                    class="btn btn-sm btn-primary"
                    @click.prevent="select('reset')"
                >
                    Reset Image Cache
                </button>
            </p>

            <p>
                <button
                    class="btn btn-sm btn-primary"
                    @click.prevent="select('builder')"
                >
                    Image Builder
                </button>
            </p>

            <p>
                <button
                    class="btn btn-sm btn-primary"
                    @click.prevent="select('url')"
                >
                    URL Tweaker
                </button>
            </p>

            <p>
                <button
                    class="btn btn-sm btn-primary"
                    @click.prevent="select('color')"
                >
                    Color Conversion
                </button>
            </p>
        </div>
    </div>
</template>

<script>
    import CacheReset from './components/CacheReset.vue';
    import ColorConversion from './components/ColorConversion.vue';
    import ImageBuilder from './components/ImageBuilder.vue';
    import UrlTweaker from './components/UrlTweaker.vue';

    export default {
        name: 'App',
        components: {
            CacheReset,
            ColorConversion,
            ImageBuilder,
            UrlTweaker,
        },
        data() {
            return {
                tool: null,
            };
        },
        methods: {
            select(tool) {
                this.tool = tool;
            },
        },
    };
</script>

<style lang="less">
    // Build customized version of Bootstrap.

    @import "./style/bootstrap/bootstrap.less";
    @import "./style/adminlte/adminlte.less";

    // Fonts.
    @import "./style/fontawesome/less/fontawesome.less";
    @import "./style/fontawesome/less/fa-light.less";
    @import "./style/fontawesome/less/fa-regular.less";
    @import "./style/fontawesome/less/fa-solid.less";

    // Style overrides.

    @import "./style/app.less";

    .tools {
        margin-top: 20px;

        max-width: 360px;

        margin-top: 20px;
        margin-left: auto;
        margin-right: auto;

        padding: 20px 20px 10px;

        border: 1px solid #d3dbe3;
        border-radius: 2px;
    }
</style>
